import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

function parseStoredUser() {
  const storedUser = localStorage.getItem('user');
  if (!storedUser) return null;
  try {
    return JSON.parse(storedUser);
  } catch {
    return null;
  }
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    // Check if user is already logged in
    return localStorage.getItem('isAuthenticated') === 'true';
  });
  const [user, setUser] = useState(() => parseStoredUser());

  useEffect(() => {
    const syncUser = () => {
      setUser(parseStoredUser());
      setIsAuthenticated(localStorage.getItem('isAuthenticated') === 'true');
    };
    window.addEventListener('storage', syncUser);
    return () => {
      window.removeEventListener('storage', syncUser);
    };
  }, []);

  const login = () => {
    setIsAuthenticated(true);
    localStorage.setItem('isAuthenticated', 'true');
    setUser(parseStoredUser());
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userCode');
    localStorage.removeItem('authToken');
    localStorage.removeItem('token');
    localStorage.removeItem('warehouseId');
    localStorage.removeItem('warehouseName');
    localStorage.removeItem('user');
    sessionStorage.clear();
    window.dispatchEvent(new Event('storage'));
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
